import React from "react";
import { useNavigate } from "react-router-dom";
import DocumentTitle from "../../components/DocumentTitle/DocumentTitle";
import "./NotFound.scss";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <DocumentTitle title="Page Introuvable - SIPIM" />
      <div className="notfound-container">
        <div className="notfound-content">
          <div className="notfound-illustration">
            <div className="error-code">404</div>
            <div className="error-icon">
              <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#ff8d13"/>
              </svg>
            </div>
          </div>
          
          <div className="notfound-text">
            <h1 className="notfound-title">Page Introuvable</h1>
            <p className="notfound-description">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
              Veuillez vérifier l'URL ou retourner à la page d'accueil.
            </p>
            
            <div className="notfound-suggestions">
              <h3>Suggestions :</h3>
              <ul>
                <li>Vérifiez l'orthographe de l'URL</li>
                <li>La page a peut-être été supprimée ou déplacée</li>
                <li>Retournez à la page précédente</li>
                <li>Accédez au tableau de bord principal</li>
              </ul>
            </div>
          </div>
          
          <div className="notfound-actions">
            <button 
              className="btn btn-primary" 
              onClick={handleGoHome}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="white"/>
              </svg>
              Accueil
            </button>
            
            <button 
              className="btn btn-secondary" 
              onClick={handleGoBack}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#ff8d13"/>
              </svg>
              Retour
            </button>
          </div>
        </div>
        
        <div className="notfound-footer">
          <p>Si le problème persiste, contactez l'administrateur système.</p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
